export default "__VITE_ASSET__BNoAWuGe__"